import { request } from './http';

export async function getPWSDailyData(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.monthId) queryParams.append('monthId', params.monthId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/pws/daily?${queryParams.toString()}`);
  }

export async function getPWSMonthlyReports(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    
    return request(`/data/pws/monthly-reports?${queryParams.toString()}`);
  }

export async function getPWSWeeklySamples(params = {}) {

    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);

    const url = `/data/pws/weekly-samples?${queryParams.toString()}`;

    return request(url);
  }

export async function createPWSWeeklySample(data) {
    return request('/data/PWSWeeklyWaterSample', {
      method: 'POST',
      body: JSON.stringify(data)
    });
  }

export async function updatePWSWeeklySample(id, data) {
    return request(`/data/PWSWeeklyWaterSample/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data)
    });
  }

export async function deletePWSWeeklySample(id) {
    return request(`/data/PWSWeeklyWaterSample/${id}`, {
      method: 'DELETE'
    });
  }

export async function getPWSMonthlySamples(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/pws/monthly-samples?${queryParams.toString()}`);
  }

export async function getPWSMonthlyUsage(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/pws/monthly-usage?${queryParams.toString()}`);
  }

export async function getPWSAnalytical(params = {}) {
    const queryParams = new URLSearchParams();
    if (params.facilityId) queryParams.append('facilityId', params.facilityId);
    if (params.startDate) queryParams.append('startDate', params.startDate);
    if (params.endDate) queryParams.append('endDate', params.endDate);
    
    return request(`/data/pws/analytical?${queryParams.toString()}`);
  }

export const pwsWaterMonitoringApi = {
  getPWSDailyData,
  getPWSMonthlyReports,
  getPWSWeeklySamples,
  createPWSWeeklySample,
  updatePWSWeeklySample,
  deletePWSWeeklySample,
  getPWSMonthlySamples,
  getPWSMonthlyUsage,
  getPWSAnalytical,
};

